export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      userUuid: '1b2c6a69f00ab0ea7583ce9b3c58b4a5',
      name: '運営者 太郎',
      email: 'aaa@aaa.com',
      roleKbn: 2,
      service: {
        serviceUuid: 'services001',
        serviceName: 'アイラ地域サポート'
      },
      linkedCmss: [
        {
          linkCMSMstId: 1,
          linkCMSMstUuid: 'linkedcms001',
          linkCMSName: 'レストラン予約CMS',
          linkCMSURL: 'https://xxx.xxx.xxx'
        },
        {
          linkCMSMstId: 3,
          linkCMSMstUuid: 'linkedcms003',
          linkCMSName: '配信管理CMS',
          linkCMSURL: 'https://xxx.xxx.xxx'
        }
      ],
      status: 1,
      lastLoginAt: 1594880785395
    }
  }
}